<template>
  <router-view />
</template>

<script>
export default {
  name: 'imports-pages-container',
};
</script>
